import loadable from 'utils/loadable';

export default loadable(
  () =>
    import(
      /* webpackChunkName: "modal.inviteFriends.termsAndConditionsModal" */ 'pages/inviteFriends/partials/TermsAndConditionsModal/TermsAndConditionsModal.component'
    ),
);
